/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityValueOverrideScope {
    COMPONENT_INTEREST = 'COMPONENT_INTEREST',
    COMPONENT_PRINCIPAL = 'COMPONENT_PRINCIPAL',
    COMPONENT_CATCH_UP = 'COMPONENT_CATCH_UP',
    COMPONENT_TRACKING = 'COMPONENT_TRACKING',
    WHOLE_SECURITY = 'WHOLE_SECURITY',
}
